import { TsDOM as q} from '@/scripts/core/TsDOM'
import { ShareButton } from '@/scripts/optional/share-button';

q.safeDefineElement(ShareButton)
